import { useHomepageHydration } from "../../context/HomepageRenderContext";
import React from "react";
import { useSelector } from "react-redux";
import { selectCartSummary, selectHasPendingServerTotals, selectCartStatus } from "../../store/cartSlice";

const formatINR = (value) => {
  const amount = Number(value) || 0;
  return `₹${amount.toLocaleString("en-IN")}`;
};

const CartSummaryPill = ({
  onClick,
  className = "",
  showLabel = true,
  showCount = true,
}) => {
  const hydrating = useHomepageHydration();
  const cartSummary = useSelector(selectCartSummary) || {};
  const hasPendingServerTotals = useSelector(selectHasPendingServerTotals);
  const status = useSelector(selectCartStatus);

  if (hydrating || !cartSummary.count) return null;

  return (
    <button
      type="button"
      className={`inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-2 py-1 text-[12px] font-semibold text-slate-900 shadow-sm transition hover:-translate-y-[1px] hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/50 ${className}`}
      onClick={onClick}
      aria-label="Open cart"
    >
      <span className="inline-flex h-6 w-6 items-center justify-center rounded-xl bg-slate-50 text-slate-700">
        <i className="fa-solid fa-cart-shopping" aria-hidden="true" />
      </span>
      {showLabel ? <span className="hidden sm:inline text-[12px]">Cart</span> : null}
      <span className="text-[12px] font-semibold">
        {hasPendingServerTotals ? (status === "loading" || status === "saving" ? "Pricing…" : "Check price") : formatINR(cartSummary.subtotal)}
      </span>
      {showCount ? (
        <span className="hidden md:inline text-[11px] text-slate-500">
          {cartSummary.count} item{cartSummary.count === 1 ? "" : "s"}
        </span>
      ) : null}
    </button>
  );
};

export default CartSummaryPill;
